import PlaceIcon from "@mui/icons-material/Place";
import styled from "styled-components";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export const Container = styled.div`
  background: #e4ebdd;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: auto;
  overflow: hidden;
  width: 100%;
`;

export const TESTE = styled.div``;

export const MosaicoWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.3) 50%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
    z-index: 1;
  }
`;

export const Hr = styled.hr`
  margin-top: 7vh;
  width: 97%;
  border: 1px solid #1a3f136c;
`;

export const ImgBuner = styled.img`
  width: 100%;
`;

export const LocalIcon = styled.img`
  width: 1.2rem;
  margin-right: 0.7rem;
`;

export const ImgBuner2 = styled.img`
  width: 100%;
`;

export const FinalTextContainer = styled.div``;

export const FinalContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

interface Props {
  src?: string;
}

export const ImgContainer2 = styled.div<Props>`
  position: relative;
  height: 100%;
  width: 100%;
  height: 100vh; /* ou a altura desejada */
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Body = styled.div`
  height: auto;
  width: 100vw;

  display: flex;
  flex-direction: column;
  z-index: 10;
`;

export const Title = styled.div`
  width: 100%;
  font-size: 2.2rem;
  font-style: italic;
  margin-left: 4vw;
  margin-right: 4vw;
  margin-top: 2vw;
`;

export const SubTitle = styled.div`
  width: 100%;
  font-size: 1.4rem;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  margin-left: 4vw;
  margin-right: 4vw;
  font-style: italic;
  color: #919191;
`;

export const ImgLogo = styled.img`
  height: 15rem;
  position: absolute;
  top: -4.5%;
  left: 5%;
`;

export const BodyText = styled.div`
  margin-top: 6vh;
  margin-left: 4vw;
  margin-right: 4vw;

  font-size: 1.5rem;
  color: #141c16;
`;

export const BodyListCardContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10vh;
  @media (max-width: 1224px) {
    margin-top: 0;
  }
`;

export const BodyListCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Card = styled.div`
  width: 50vw;
  height: 17vh;
  margin-bottom: 20vh;
  color: #000000;
  border-radius: 10px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  @media (max-width: 1224px) {
    width: 90vw;
    height: auto;
  }
`;

export const Line = styled.div`
  width: 0.5rem; /* Define a largura da linha */
  height: auto; /* Altura total ou personalizada */
  background-color: #a71c13; /* Cor da linha */
`;

export const LineFinal = styled.div`
  transform: translateX(-50%);
  top: 50%;
  left: 30%;
  margin-right: 2rem;
  width: 0.5rem; /* Define a largura da linha */
  height: 30vh; /* Altura total ou personalizada */
  background-color: #a71c13; /* Cor da linha */
`;

export const CardTitleContainer = styled.div``;

export const TitleCard = styled.h1`
  font-weight: bolder;
`;

export const SUbText = styled.p``;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-top: 1.5rem;
  width: 100%;

  @media (max-width: 1224px) {
    margin-top: 2rem;
  }
  @media (max-width: 768px) {
    margin-top: 2rem;
    align-items: start;
    flex-direction: column;
  }
`;

export const CardIcon = styled.div`
  margin-right: 2rem;

  @media (max-width: 1224px) {
    margin-bottom: 2rem;
  }
`;

export const CardIconImg = styled.img`
  height: 5rem;
`;

export const CardText = styled.div`
  margin-left: 1rem;
  width: 100% !important;
`;

export const Faixa = styled.div`
  width: 100%;
  height: 20vh;

  margin-top: 4vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FaixaText = styled.div`
  color: #141c16;
  font-size: 1.3rem;
  padding-left: 3rem;
  padding-right: 3rem;  
  z-index: 2;
  text-align: center;
  font-weight: bolder;

  @media (max-width: 900px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const Esclamacao = styled.img`
  height: 14rem;
  position: absolute;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
`;

export const TitleFinalContainer = styled.div`
  font-size: 1.7rem;
  font-weight: bolder;
  margin-bottom: 1rem;
`;

export const TextFinalContainer = styled.div`
  font-size: 1.3rem;
  font-weight: bolder;
`;

export const Galeria = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 70%; // Alterado para 70% da largura
  margin: 0 auto; // Centraliza o container
  padding: 2rem 0; // Ajuste no padding
  background-color: #e4ebdd;
  margin-bottom: 5rem;

  @media (max-width: 1224px) {
    width: 85%; // Aumenta a porcentagem em telas menores
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 1600px) {
    max-width: 1200px; // Limita a largura máxima
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  aspect-ratio: 1/1; /* Mantém proporção quadrada */

  &:hover {
    transform: scale(1.03);
    z-index: 2;
  }

  @media (max-width: 768px) {
    aspect-ratio: 16/9; /* Proporção mais larga em mobile */
  }
`;

export const ImgContainer = styled.div`
  position: relative;
  overflow: hidden;

  &:hover {
    img {
      transform: scale(1.05);
    }
  }
`;

// export const VideoContainer = styled.div`
//   width: 100%;
//   padding: 4rem;
//   display: flex;
//   justify-content: center;
//   margin-bottom: 5rem;
// `;

export const VideoContainerB = styled.div`
  padding-left: 12rem;
  display: flex;
  width: 100%;
  @media (max-width: 1224px) {
    justify-content: center;
    padding-left: 0;
  }
`;

// export const VideoGrid = styled.div`
//   display: grid;
//   width: 80%;
//   grid-template-columns: repeat(2, 1fr);
//   gap: 2rem;
//   margin: 0 auto;
//   margin-left: 1.5rem;
//   margin-right: 1.5rem;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }
// `;

// export const VideoCard = styled.div`
//   cursor: pointer;
//   transition: transform 0.3s ease;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;

//   &:hover {
//     transform: translateY(-5px);
//   }
//   @media (max-width: 1224px) {
//     justify-content: center;
//     align-items: start;
//   }
// `;

// export const VideoThumbnail = styled.div`
//   position: relative;
//   background: #000;
//   height: 50vh;
//   iframe {
//     pointer-events: none;
//   }
// `;

export const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 0 1rem;
  z-index: 99;
`;

export const VideoContainerAlt = styled(VideoContainer)`
  width: 100%;
`;

export const VideoGrid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
`;

export const VideoCard = styled.div`
  flex: 0 1 calc(45% - 1rem); /* ocupa metade da linha */
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.03);
  }

  @media (max-width: 720px) {
    flex: 0 1 100%; /* em telas menores: 1 por linha */
  }
`;

export const VideoCardAlt = styled(VideoCard)`
  flex: 0 1 90%;
  padding-left: 3rem;
  padding-right: 3rem;
  
  @media (max-width: 900px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const VideoThumbnail = styled.div`
  height: 30rem;
  width: 100%;
  @media (max-width: 900px) {
    height: 15rem;
  }
  @media (max-width: 720px) {
    height: 15rem;
  }
`;

export const VideoThumbnailAlt = styled.div`
  height: 30rem;
  width: 50%;
  @media (max-width: 900px) {
    width: 100%;
    height: 20rem;
  }
  @media (max-width: 720px) {
    height: 18rem;
  }
`;

export const VideoThumbnailB = styled.div`
  position: relative;
  background: #000;
  height: 50vh;
  width: 40vw;
  iframe {
    pointer-events: none;
  }

  @media (max-width: 1224px) {
    width: 100%;
  }
`;

export const VideoCardTitle = styled.div`
  padding-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #000000;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  background-color: #e4ebdd;
  z-index: 10 !important;
`;

export const VideoTitle = styled.div`
  width: 85%;
  display: flex;
  font-size: 1.7rem;
  font-weight: bolder;
  margin-top: 6vh;
  margin-bottom: 2vh;
  justify-content: start;
  align-items: start;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const NavButton = styled.button`
  pointer-events: all; /* Habilita cliques nos botões */
  background-color: rgba(225, 225, 225, 0);
  border: none;
  color: #000000 !important;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    transition: 0.3s;
    transform: scale(1.2);
  }
`;

export const VideoWrapperA = styled.div`
  width: 80vw;
  height: 80vh;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowLeft = styled(ArrowBackIosIcon)`
  margin-left: 3rem;
`;

export const ArrowRight = styled(ArrowBackIosIcon)`
  transform: rotate(-180deg);

  margin-right: 3rem;
`;

export const TitleSection1 = styled.div`
  font-size: 1.5rem;
  font-weight: bolder;
  font-style: italic;
  color: #323d09;
  font-family: "Montserrat", sans-serif;
`;

export const ProjectoSectionContainer = styled.div`
  background-color: #c2cfb4;
  width: 100%;
`;

export const ProjectoSection = styled.div`
  background-color: #c2cfb4;
  padding-top: 3vh;
  padding-bottom: 3vh;
  color: #141c16;
  padding-left: 7rem;
  padding-right: 7rem;
  padding-bottom: 7rem;
`;

export const CardProjeto = styled.div`
  background-color: #4e5c2c;
  display: flex;
  margin-top: 3vh;
  justify-content: start;
  align-items: start;
  margin-right: 1vw;
  flex-direction: column;
  height: auto;
  width: 100%;
  transition: 0.3s;
  border-radius: 10px;
  padding-bottom: 2rem;
  &:hover {
    border: 1px solid #c2cfb4;
    cursor: pointer;
    transition: 0.6s;
    transform: scale(1.05);
  }
`;

export const CardMainContainer = styled.div`
  background-color: #4e5c2c;
  display: flex;
  border-radius: 10px;

  justify-content: start;
  align-items: start;
  margin-right: 1vw;
  flex-direction: row;
  height: auto;
  width: 100%;
`;

export const InicialSecao = styled.section`
  width: 100%;
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  box-sizing: border-box;

  @media (max-width: 600px) {
    padding: 1rem 0;
  }
`;

export const CardImgFremeProjetoA = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 10rem;
    height: auto;
    display: block;
  }

  @media (max-width: 600px) {
    max-width: 180px;
  }
`;

export const CardImgProjetoA = styled.img<Props>`
  height: 100%; /* Faz com que a imagem preencha a altura do contêiner */
  width: 100%; /* Faz com que a imagem preencha a largura do contêiner */
  object-fit: cover; /* Garante que a imagem mantenha proporções e preencha o contêiner */
  object-position: center; /* Centraliza a imagem dentro do contêiner */
`;

export const CardImgProjetoB = styled.img<Props>`
  height: 100%; /* Faz com que a imagem preencha a altura do contêiner */
  width: 100%; /* Faz com que a imagem preencha a largura do contêiner */
  object-fit: cover; /* Garante que a imagem mantenha proporções e preencha o contêiner */
  object-position: center; /* Centraliza a imagem dentro do contêiner */
  z-index: 0;
`;

export const CardImgProjeto = styled.img<Props>`
  height: 100%; /* Faz com que a imagem preencha a altura do contêiner */
  width: 100%; /* Faz com que a imagem preencha a largura do contêiner */
  object-fit: cover; /* Garante que a imagem mantenha proporções e preencha o contêiner */
  object-position: center; /* Centraliza a imagem dentro do contêiner */
`;

export const CardTextContainerProjeto = styled.div`
  height: 100%;
  margin-left: 1rem;
  width: auto;
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
`;

export const CardTitleProjeto = styled.div`
  font-size: 1.3rem;
  margin-top: 0.5rem;
  color: #c2cfb4;
  font-family: "Montserrat", sans-serif;
`;

export const CardTextProjeto = styled.div`
  color: #ffffff;
  margin-top: 0.5rem;
  font-size: 1.3rem;
  word-spacing: 10px;
`;

export const LogoEcoacao = styled.img`
  width: 17rem;
  margin-bottom: 5vh;
`;

export const TitleSectio = styled.h1`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  position: relative;
`;

export const TitleInicial = styled.h1`
  font-size: 10rem !important;
  margin-top: 5vh;
  color: #000000;

  @media (max-width: 1224px) {
    font-size: 6rem !important;
  }
`;

export const CardImgFremeProjeto = styled.div<Props>`
  height: 26vh;
  width: 100% !important;
  padding-top: 2rem;
  margin-left: 1rem;
  overflow: hidden; /* Corta o conteúdo que exceder os limites do contêiner */
  position: relative; /* Garante que o posicionamento seja relativo ao contêiner */
`;

export const TextoSubInicial = styled.p`
  color: #000000;
  text-align: center;
  margin: 0 2rem !important;
`;

export const TextoSubInicialContainer = styled.div`
  font-size: 1.4rem !important;
  color: #988041;
  font-style: italic;
  display: flex;
  flex-direction: row;
  margin: 0 2rem !important;
`;

export const TextoSubInicialA = styled.p`
  font-size: 1.4rem !important;
  color: #988041;
  font-style: italic;
  display: flex;
  flex-direction: row;
  text-align: center;
`;

export const PlaceIconA = styled(PlaceIcon)`
  color: #988041;
`;

export const TextImgCardMain = styled.div`
  width: 100%;
  min-height: 70vh;
  display: flex;
  padding-left: 7rem;
  padding-right: 7rem;
  justify-content: end;
  align-items: center;
  margin-bottom: 25vh;
  margin-top: 1rem;
`;

export const TextImgCard = styled.div`
  position: relative; /* Necessário para que os pseudo-elementos se posicionem em relação a esse container */
  width: 96%;
  height: 97%;
  padding-right: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  z-index: 0;

  @media (max-width: 1224px) {
    flex-direction: column-reverse;
  }

  /* Borda de cima: 96% da largura, alinhada à direita */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 98%;
    border-top: 2px solid #c6baaf;
    z-index: 0;
  }

  @media (min-width: 768px) {
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: 70%;
      border-bottom: 2px solid #c6baaf;
      z-index: 0;

      @media (max-width: 1224px) {
        width: 100%;
      }
    }
  }
`;

export const ImgCard = styled.div`
  position: relative; /* Necessário para o posicionamento absoluto do ::before */
  height: 99%;
  width: 88%;

  /* Borda esquerda com pequenas extensões para cima e para baixo */
  /* Borda direita que não afeta os demais elementos */
  &::before {
    content: "";
    position: absolute; /* Permite que a borda fique fixa na viewport */
    left: 0;
    top: -100px; /* Faz a borda "vazar" um pouco para cima */
    height: 140%; /* Ocupa a altura total da viewport */
    width: 2px;
    background: #c6baaf;
    z-index: 0; /* Garante que fique sobre outros elementos, se necessário */
  }

  /* Borda direita que não afeta os demais elementos */
  &::after {
    content: "";
    position: absolute; /* Permite que a borda fique fixa na viewport */
    right: 0;
    top: -60px; /* Faz a borda "vazar" um pouco para cima */
    height: 120vh; /* Ocupa a altura total da viewport */

    width: 2px;
    background: #c6baaf;
    z-index: 0; /* Garante que fique sobre outros elementos, se necessário */
  }
`;

export const TextCard = styled.p`
  width: 70%;
  font-size: 1.4rem !important;
  padding-left: 10rem !important;
  padding-right: 4rem !important;
  padding-bottom: 2rem !important;
  padding-top: 1rem !important;

  @media (max-width: 1224px) {
    padding-left: 2rem !important;
    padding-right: 5rem !important;
  }
`;

export const StyledListItem = styled.p`
  list-style: none; /* Remove o marcador padrão */
  position: relative;
  padding-left: 1.2em; /* Espaço para o marcador customizado */
  padding-right: 2rem;
  &::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 0;
    /* Ajuste o 'top' para alinhar verticalmente se necessário */
  }
`;

// Adicione estas linhas no final do seu arquivo de estilos
export const ReportVideoContainer = styled.div`
  width: 100%;
  padding: 4rem;
  background-color: #e4ebdd;
  margin-bottom: 5rem;
`;

export const ReportVideoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const ReportVideoCard = styled.div`
  cursor: pointer;
  transition: transform 0.3s ease;
  overflow: hidden;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  &:hover {
    transform: translateY(-5px);
  }

  &:hover {
    transform: translateY(-5px);
  }
`;

export const MainTitleContainer = styled.div`
  width: 100%;
`;

export const MainTitle = styled.h1`
  padding-left: 3rem;
  padding-right: 3rem;
  
  @media (max-width: 900px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const OrganisationCard = styled.ul`
  width: 100%;
  text-align: left;
  padding-left: 5rem;
  padding-bottom: 3rem;

  @media (max-width: 1224px) {
    width: 85%;
  }

  @media (max-width: 768px) {
    padding-left: 2rem;
  }
`;

export const LinhaHorizontal = styled.div`
  width: 90%;
  height: 2px;
  background-color: #c6baaf; /* Cor da linha */
  margin: 1rem 0;
  margin-bottom: 5rem;
`;

export const CreditosTitle = styled.h2``;
export const CreditosList = styled.ul``;
export const CreditosItem = styled.li`
  font-size: 1.2rem;
`;

export const CreditosContainer = styled.div`
  background-color: #b8c5aa;
  display: flex;
  flex-direction: column;
  height: auto;
  padding-top: 5vh;
  padding: 80px;
  position: relative;

  @media (max-width: 768px) {
    padding: 20px !important; /* Ajuste de padding para mobile */
  }
`;

export const Organizacao = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  width: 100%;
  @media (max-width: 1224px) {
    align-items: center;
    flex-direction: column-reverse;
  }
`;

export const OrganizacaoCard = styled.div`
  width: 100%;
`;
